import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ChevronRightSmall from "../../../ui/icons/other/chevron-right-small"
import Button from "../../button"
import ArticleCard from "./article-card"
import FeaturedArticleCard from "./featured-article-card"
import ArticleIcon from "../../icons/article-icon"

const data = {
  title: "Check out our latest articles",
  subTitle: "Stay sharp with the latest updates in tech industry!",
}

const ExploreArticles = () => {
  const { articles } = useStaticQuery(graphql`
    {
      articles: allWpPost(
        sort: { date: DESC }
        limit: 5
        filter: {
          spotlight: { eq: true }
          categories: { nodes: { elemMatch: { parentId: { eq: null } } } }
        }
      ) {
        edges {
          node {
            id
            slug
            title
            date
            featuredImage {
              node {
                mediaItemUrl
                mediaDetails {
                  sizes {
                    name
                    sourceUrl
                    height
                    width
                  }
                }
              }
            }
            categories {
              nodes {
                name
                slug
              }
            }
          }
        }
      }
    }
  `)

  const [featuredArticle, ...otherArticles] = articles.edges

  return (
    <div className="container-lg flex flex-col gap-8 sm:gap-10 mt-20  sm:mt-[100px] md:mt-[120px]">
      <div>
        <div className="text-jar-6 font-semibold text-neutral-12">
          {data.title}
        </div>
        <p className="text-jar-4 text-neutral-11 mt-1">{data.subTitle}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FeaturedArticleCard
          key={featuredArticle.node.slug}
          slug={featuredArticle.node.slug}
          cover={
            featuredArticle.node.featuredImage?.node?.mediaItemUrl ||
            featuredArticle.node.featuredImage?.node?.mediaDetails?.sizes?.find(
              ({ name }) => name === "medium"
            )?.sourceUrl
          }
          title={featuredArticle.node.title}
          date={featuredArticle.node.date}
          className="w-full"
          imagePriority="high"
          categories={featuredArticle.node.categories.nodes}
        />

        <div className="flex flex-col gap-6">
          {otherArticles.map(
            ({
              node: { title, slug, featuredImage, authors, categories, date },
            }) => {
              const imageSizes = featuredImage?.node?.mediaDetails?.sizes ?? []
              const thumbnail = imageSizes.find(({ name }) => name === "medium")
              const cover =
                thumbnail?.sourceUrl || featuredImage?.node?.mediaItemUrl
              return (
                <ArticleCard
                  key={slug}
                  slug={slug}
                  date={date}
                  cover={cover}
                  title={title}
                  categories={categories.nodes}
                  className="w-full"
                />
              )
            }
          )}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 p-8 bg-neutral-2 rounded-2xl sm:items-center">
        <ArticleIcon />
        <div className="flex-grow gap-1">
          <div className="text-jar-6 font-semibold text-neutral-12">
            Explore all articles
          </div>
          <p className="text-jar-4 text-neutral-11">
            Discover a world of insights - browse our complete collection of
            articles in one place!
          </p>
        </div>
        <Button
          variant="solid"
          color="neutral"
          className="w-full sm:w-auto mt-6 h-10"
          asChild
        >
          <a
            href="/blog/"
            className="text-jar-3 font-medium flex gap-1 my-auto"
          >
            <span>See all articles</span>
            <ChevronRightSmall className="my-auto" />
          </a>
        </Button>
      </div>
    </div>
  )
}

export default ExploreArticles
